<template>
  <div class="vue-template">
    <div class="error-text mt-2" v-for="(error, index) in errors" :key="index">{{ error }}</div>

    <InputsSettings
      :user="user"
      :specialties="specialties"
      @submitedform="validator($event)"
      :lastSpecialty="lastSpecialty"
    />

    <v-divider class="mb-1" />

    <Security />
  </div>
</template>
<script>
import { auth, db } from "@/config/firebaseConfig";
import Security from "./Security";
import InputsSettings from "./InputsSettings";

export default {
  props: ["dataUser"],
  components: { Security, InputsSettings },
  mounted() {
    this.hasSpecialty(this.dataUser.specialty);
  },
  data() {
    return {
      user: {
        name: this.dataUser.name || "",
        userName: this.dataUser.userName || "",
        specialty: this.dataUser.specialty || "",
      },
      errors: [],
      snapshot: null,
      specialties: this.$t("LoggedArea.Settings.InputsSettings.specialties"),
      lastSpecialty: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    hasSpecialty(specialty) {
      const contains = this.specialties.indexOf(specialty);
      if (specialty != undefined && contains == -1) {
        const lastSpecialty = this.specialties.pop();
        this.lastSpecialty = lastSpecialty;
        this.specialties.push(specialty);
      } else return;
    },
    async validator() {
      this.user.id = auth.currentUser.uid;
      this.errors = [];
      try {
        this.$store.commit("setLoading", true);
        const usersRef = db.ref("/users");
        this.user.userName = this.user.userName
          .toLowerCase()
          .replace(/\s/g, "")
          .replace(/[^a-zA-Z.]/g, "");
        usersRef
          .orderByChild("userName")
          .equalTo(this.user.userName)
          .once("value", async (snapshot) => {
            this.snapshot = null;
            snapshot.forEach((childsnapshot) => {
              this.snapshot = childsnapshot.key;
            });
            if (this.snapshot != null && this.snapshot != this.user.id) {
              this.$store.commit("setLoading", false);
              this.errors.push(
                this.$t("LoggedArea.Settings.InputsSettings.userNameExist")
              );
            }
            if (this.user.name == "") {
              this.$store.commit("setLoading", false);
              this.errors.push(
                this.$t(
                  "LoggedArea.Settings.InputsSettings.profileNameRequired"
                )
              );
            }
            if (this.user.userName == "") {
              this.$store.commit("setLoading", false);
              this.errors.push(
                this.$t("LoggedArea.Settings.InputsSettings.userNameRequired")
              );
            }
            if (this.user.name.length > 25) {
              this.$store.commit("setLoading", false);
              this.errors.push(
                this.$t("LoggedArea.Settings.InputsSettings.profileNameLength")
              );
            }
            if (this.user.userName.length > 25) {
              this.$store.commit("setLoading", false);
              this.errors.push(
                this.$t("LoggedArea.Settings.InputsSettings.userNameLength")
              );
            }
            if (this.user.specialty == "") {
              this.$store.commit("setLoading", false);
              this.errors.push(
                this.$t("LoggedArea.Settings.InputsSettings.specialtyRequired")
              );
            }
            if (this.errors.length == 0) {
              this.sendInfoUser();
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    async sendInfoUser() {
      const data = {
        userName: this.user.userName,
        name: this.user.name.replace(
          /[^A-Za-z0-9 _]*[^A-Za-z0-9][^A-Za-z0-9 _]*$/,
          ""
        ),
        specialty: this.user.specialty,
      };
      await this.$http.patch(
        `users/${this.user.id}.json?auth=${this.token}`,
        data
      );
      this.error = "";
      const formData = {
        userForm: false,
        active_tab: 1,
      };
      this.$emit("useChanged", data);
      this.$emit("changeForm", formData);
      this.$store.commit("changeSettings", data);
      this.$store.commit("setLoading", false);
    },
  },
};
</script>

<style>
.btn-logged-area {
  display: flex;
  justify-content: space-around;
  padding-left: 10px;
}
</style>